import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  error: "",
  pageLoading: false,
  invoiceRegistryLoading: false,
  invoiceRegistry: [],
  invoiceRegistryPagination: {},
});

export default function invoiceRegistryReducers(state = initialState, action) {
  switch (action.type) {
    // InvoiceRegistry sorting
    case ACTIONS.SORT_INVOICE_REGISTRY.PENDING: {
      return state.set("error", "").set("pageLoading", true);
    }
    case ACTIONS.SORT_INVOICE_REGISTRY.SUCCESS: {
      return state
        .set("pageLoading", false)
        .set("error", "")
        .set("invoiceRegistry", action.data.data)
        .set("invoiceRegistryPagination ", action.data.pagination);
    }
    case ACTIONS.SORT_INVOICE_REGISTRY.ERROR: {
      return state.set("pageLoading", false).set("error", action.error);
    }

    // InvoiceRegistry listing
    case ACTIONS.INVOICE_REGISTRY.PENDING: {
      return state.set("error", "").set("pageLoading", true);
    }
    case ACTIONS.INVOICE_REGISTRY.SUCCESS: {
      return state
        .set("pageLoading", false)
        .set("error", "")
        .set("invoiceRegistry", action.data.data)
        .set("invoiceRegistryPagination", action.data.pagination);
    }
    case ACTIONS.INVOICE_REGISTRY.ERROR: {
      return state.set("pageLoading", false).set("error", action.error);
    }

    // Create InvoiceRegistry
    case ACTIONS.CREATE_INVOICE_REGISTRY.PENDING: {
      return state.set("invoiceRegistryLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_INVOICE_REGISTRY.SUCCESS: {
      return state
        .set("invoiceRegistryLoading", false)
        .set("error", "")
        .set("invoiceRegistry", action.data.data)
        .set("invoiceRegistryPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_INVOICE_REGISTRY.ERROR: {
      return state
        .set("error", action.error)
        .set("invoiceRegistryLoading", false);
    }

    // Update InvoiceRegistry
    case ACTIONS.UPDATE_INVOICE_REGISTRY.PENDING: {
      return state.set("invoiceRegistryLoading", true).set("error", "");
    }
    case ACTIONS.UPDATE_INVOICE_REGISTRY.SUCCESS: {
      return state
        .set("invoiceRegistryLoading", false)
        .set("error", "")
        .set("invoiceRegistry", action.data.data)
        .set("invoiceRegistryPagination", action.data.pagination);
    }
    case ACTIONS.UPDATE_INVOICE_REGISTRY.ERROR: {
      return state
        .set("error", action.error)
        .set("invoiceRegistryLoading", false);
    }

    // Delete InvoiceRegistry
    case ACTIONS.DELETE_INVOICE_REGISTRY.PENDING: {
      return state.set("error", "").set("invoiceRegistryLoading", true);
    }
    case ACTIONS.DELETE_INVOICE_REGISTRY.SUCCESS: {
      return state
        .set("error", "")
        .set("invoiceRegistryLoading", false)
        .set("invoiceRegistry", action.data.data)
        .set("invoiceRegistryPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_INVOICE_REGISTRY.ERROR: {
      return state
        .set("error", action.error)
        .set("invoiceRegistryLoading", false);
    }

    default: {
      return state;
    }
  }
}
